export const notFound = {
  title: 'Hoppá! Az oldal nem található.',
  description:
    'Úgy tűnik, a keresett oldal nem létezik. Ellenőrizze a címet, vagy térjen vissza a kezdőlapra.',
  backToHome: 'Vissza a kezdőlapra',
  imageAlt: '404 – az oldal nem található',
};
